import { useLeanProductQuery } from "@faire/retailer-visitor-shared/views/product/utils/useLeanProductQuery";
import { useMemo } from "react";

import { IBrandReviewSummary } from "./interfaces";

export const useBrandReviewSummaryLean = (
  productToken: string
): IBrandReviewSummary => {
  const { data: resolvedProductResponse } = useLeanProductQuery(productToken);

  const overallRatingText: string | undefined = useMemo(() => {
    return resolvedProductResponse?.brand?.average_rating;
  }, [resolvedProductResponse]);

  const numberOfReviews: number | undefined = useMemo(() => {
    return resolvedProductResponse?.brand?.number_of_reviews;
  }, [resolvedProductResponse]);

  return { overallRatingText, numberOfReviews };
};
